<template>
  <section class="section-6 grey wrapper">
    <div class="hd hd-flip">
      <h2 class="title">
        线下回顾花絮
      </h2>
    </div>

    <div
      v-for="item in firstChild"
      :key="item.id"
      :href="item.url"
      target="_blank"
      class="content-item big"
      @click="onClick(item)"
    >
      <div class="content-item__thumb">
        <img src="~assets/big-poster.png">
      </div>
      <div class="big-wrap">
        <div style="overflow: hidden; text-align: right">
          <span class="content-item__video-tag">
            视频
          </span>
          <span
            v-for="(s, i) in item.describes"
            :key="i"
            class="content-item__tags"
            :class="{
              'content-item__time': i === 0,
              'content-item__addr': i === 1
            }"
          >
            <img
              v-if="i === 0"
              src="~assets/clock@2x.svg"
              alt=""
            >
            <img
              v-if="i === 1"
              src="~assets/map@2x.svg"
              alt=""
            >
            {{ s }}
          </span>
        </div>
        <h5>{{ item.title }}</h5>
      </div>
    </div>

    <div class="content">
      <div
        v-for="item in restChild"
        :key="item.id"
        :href="item.url"
        target="_blank"
        class="content-item"
        @click="onClick(item)"
      >
        <div class="content-item__thumb">
          <img :src="item.web_thumb">
        </div>
        <div style="overflow: hidden">
          <span class="content-item__video-tag">
            视频
          </span>
          <span
            v-for="(s, i) in item.describes"
            :key="i"
            class="content-item__tags"
            :class="{
              'content-item__time': i === 0,
              'content-item__addr': i === 1
            }"
          >
            {{ s }}
          </span>
        </div>
        <h5>{{ item.title }}</h5>
      </div>
    </div>

    <btn-contact name="B页-线下回顾花絮-预约咨询" />

    <transition name="fade">
      <div
        v-if="visible"
        class="dialog"
        :class="{
          visible: visible
        }"
      >
        <div
          class="dialog-mask"
          @touchmove.prevent=""
          @click="onDialogChange(false)"
        />
        <div class="dialog-container">
          <i
            class="btn-close"
            @click="onDialogChange(false)"
          />
          <div class="video-container">
            <video
              ref="player"
              controls
              webkit-playsinline="true"
              playsinline="true"
              x5-video-player-type="h5-page"
              x5-video-player-fullscreen="true"
              t7-video-player-type="inline"
              x-webkit-airplay="true"
              preload="true"
              :poster="video.poster"
              :src="video.link"
            />
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import { getActivityDataById } from '@/api';
import BtnContact from './BtnContact.vue';

export default {
  components: {
    BtnContact,
  },
  data() {
    return {
      list: [],
      visible: false,
      video: {
        link: '',
        poster: '',
      },
      isFullScreen: false,
    };
  },
  computed: {
    firstChild() {
      return this.list.slice(0, 1);
    },
    restChild() {
      return this.list.slice(1, this.list.length);
    },
  },
  mounted() {
    getActivityDataById({ id: 1095 }).then((res) => {
      const list = res.data.list.length ? res.data.list[0].items : [];
      this.list = list.length > 9 ? list.slice(0, 9) : list;
    });

    this.jsBridge = new window.Jin10JSBridge();
  },
  methods: {
    onClick(data) {
      // eslint-disable-next-line no-underscore-dangle
      (window._czc || []).push(['_trackEvent', `B页-${data.title}`, 'click', window.location.href]);

      if (this.jsBridge.isApp) {
        this.jsBridge.dispatch('openAppVideoPlayer', {
          id: data.id,
          play_type: 0,
        });
      } else {
        this.video = {
          link: data.url,
          poster: data.web_thumb,
        };
        this.onDialogChange(true);
        this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        this.$nextTick(() => {
          this.$refs.player.play();
          this.$refs.player.addEventListener('fullscreenchange', () => {
            this.onFullScreenChange();
          });
          // 兼容webkit内核浏览器
          this.$refs.player.addEventListener('webkitfullscreenchange', () => {
            this.onFullScreenChange();
          });
        });
      }
    },
    onDialogChange(bool) {
      this.visible = bool;
    },
    onFullScreenChange() {
      this.isFullScreen = !this.isFullScreen;
      if (!this.isFullScreen) {
        setTimeout(() => {
          window.scrollTo(0, this.scrollTop);
        }, 500);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@front-end/components/lib/player/index.css';

.section-6 {
  padding-top: percentage(140px / $deviceWidth);
  padding-bottom: percentage(100px / $deviceWidth);

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: percentage(305px / $deviceWidth);
    padding-top: percentage(361px / $deviceWidth);
    margin-top: percentage(-165px / $deviceWidth);
    background: url("~assets/camera.png") center/contain no-repeat;
    @include hdpi() {
      background-image: url("~assets/camera@2x.png");
    }
  }

  &.active {
    .content {
      &-item {
        animation: fadeInUp .6s .6s both;

        @for $i from 1 through 10 {
          &:nth-of-type(#{$i}) {
            animation-delay: #{$i * 0.2s + 0.4s};
          }
        }
      }
    }
  }

  .title {
    margin-right: percentage(214px / $deviceWidth);
    width: percentage(607px / $deviceWidth);
    padding-top: percentage(142px / $deviceWidth);
  }

  .content {
    $contentWidth: 1440px;
    margin: 0 auto percentage(64px / $deviceWidth);
    width: percentage($contentWidth / $deviceWidth);
    text-align: left;

    &-item {
      opacity: 0;
      display: inline-block;
      width: percentage(330px / $contentWidth);
      margin-right: percentage(40px / $contentWidth);
      margin-bottom: percentage(60px / $contentWidth);
      text-decoration: none;
      vertical-align: top;
      cursor: pointer;

      &.big {
        width: 100%;
        margin-top: percentage(56px / $deviceWidth);
        margin-bottom: percentage(52px / $deviceWidth);
        margin-right: 0;

        .content-item {
          &__thumb {
            margin-bottom: 0;
            padding-top: percentage(480px / $deviceWidth);
            &::after {
              opacity: 1;
              width: percentage(103px / $deviceWidth);
              padding-top: percentage(105px / $deviceWidth);
            }
            &:hover {
              &::after {
                opacity: 1;
                transform: translate(-50%, -50%) scale(.65);
              }
              img {
                transform: translate(-50%, 0);
              }
            }
          }
          &__video-tag {
            position: relative;
          }

          &__tags {
            position: relative;
            float: none;
            display: inline-flex;
            padding: 0 12px;
            background: rgba(255, 255, 255, .4);
            color: #fff;
            &::after {
              content: none;
            }

            img {
              width: 20px;
              height: 22px;
              margin-right: 6px;
            }
          }
        }
        h5 {
          padding: percentage(24px / 695px);
          margin: percentage(20px / 695px) 0;
          background-color: #fff;
          text-align: left;
        }
        .big-wrap {
          margin: percentage(-98px / $deviceWidth) auto 0;
          width: percentage(695px / $deviceWidth);
        }
      }

      &:nth-of-type(4n) {
        margin-right: 0;
      }

      &__thumb {
        position: relative;
        padding-top: percentage(186px / 330px);
        margin-bottom: percentage(20px / 330px);
        overflow: hidden;

        &::after {
          content: "";
          position: absolute;
          @include center();
          opacity: 0;
          transform: translate(-50%, -50%) scale(.65);
          transition: all .3s;
          width: percentage(64px / 420px);
          padding-top: percentage(64px / 420px);
          background: url("~assets/player.png") center/contain no-repeat;
          @include hdpi() {
            background-image: url("~assets/player@2x.png");
          }
        }

        img {
          @include center();
          top: 0;
          transform: translate(-50%, 0);
          width: 100%;
          height: 100%;
          transition: all .3s;
          will-change: transform;
        }

        &:hover {
          &::after {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1);
          }
          img {
            transform: translate(-50%, 0) scale(1.1);
          }
        }
      }

      h5 {
        position: relative;
        margin: percentage(20px / 330px) auto;
        font-size: 22px;
        color: #3A4047;
        line-height: 1.5;
        @include ellipse(2);

        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translate(-50%, 0);
          margin-bottom: percentage(-32px / 480px);
          width: 72px;
          height: 3px;
          background-color: #3773CB;
        }
      }

      &__tags {
        float: right;
        display: inline-block;
        align-items: center;
        font-size: 20px;
        line-height: 28px;
        color: #878E96;
        margin-left: 10px;

        &:nth-last-of-type(1) {
          margin-right: 0;
        }
      }

      &__video-tag {
        float: left;
        padding: 0 14px;
        font-size: 18px;
        line-height: 28px;
        color: #fff;
        background-color: #305EE0;
      }

      &__time {
        position: relative;

        &::after {
          content: "·";
          position: absolute;
          left: -8px;
          top: 0;
        }
        // background: rgba(185,195,206, 0.2) url("~assets/clock@2x.png") 12px center/22px 22px no-repeat;
      }

      // &__addr {
      //   background: rgba(185,195,206, 0.2) url("~assets/map@2x.png") 12px center/19px 24px no-repeat;
      // }
    }
  }

  @include mediaWidth(1440px) {
    .content {
      &-item {
        h5 {
          font-size: 16px;
        }

        &__video-tag, &__tags {
          font-size: 14px;
          line-height: 24px;
        }

        &__video-tag {
          padding: 0 10px;
        }
      }
    }
  }

  @include mediaWidth(1024px) {
    .title {
      margin-right: percentage(76px / 1024px);
    }
    .content {
      width: 86%;

      &-item {
        margin-right: 2%;

        &__tags, &__video-tag {
          font-size: 12px;
        }
      }
    }
  }

  @include mediaWidth(#{$mbWidth}) {
    padding-top: percentage(64px / $mbWidth);
    padding-bottom: percentage(46px / $mbWidth);

    &::before {
      content: none;
    }
    .title {
      width: percentage(309px / $mbWidth);
      padding-top: percentage(88px / $mbWidth);
    }
    .content {
      width: percentage(680px / $mbWidth);
      margin: 0 auto percentage(40px / $mbWidth);
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      &-item {
        flex-shrink: 0;
        width: percentage(320px / 680px);
        margin-right: 0;

        h5 {
          font-size: 14px;
          line-height: 20px;
          @include ellipse(2);
        }

        span {
          font-size: 12px;
          line-height: 22px;
        }

        &.big {
          .content-item {
            &__thumb {
              &::after {
                width: percentage(61px / $mbWidth);
                padding-top: percentage(62px / $mbWidth);
              }
            }
          }
          .big-wrap {
            margin: percentage(-47px / $mbWidth) auto 0;
            width: percentage(680px / $mbWidth);
          }
        }
      }
    }
  }

  @include mediaWidth(528px) {
    .content {
      &-item {
        h5 {
          font-size: 12px;
        }
        &__tags {
          font-size: 10px;
          padding: 0 4px;
        }
      }
    }
  }

  .dialog {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;

    &-mask {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, .6);
    }

    &.visible {
      .dialog-container {
        animation: bounceIn .8s .2s both;
      }
    }

    .btn-close {
      position: absolute;
      right: -34px;
      top: -49px;
      width: 34px;
      height: 34px;
      background: url("~assets/btn-close.png") center/contain no-repeat;
      transition: all .3s ease-in-out;
      cursor: pointer;

      &:hover {
        transform: rotate(180deg);
      }
    }

    .video-container {
      width: 720px;
      height: 405px;
      font-size: 16px;

      video {
        width: 100%;
        height: 100%;
      }

      ::v-deep {
        .jin-player {
          width: 100%;
        }
      }
    }

    @include mediaWidth(#{$mbWidth}) {
      &-container {
        width: 100%;
      }
      .btn-close {
        top: -42px;
        right: 16px;
        width: 24px;
        height: 24px;
      }
      .video-container {
        position: relative;
        width: 86%;
        height: auto;
        padding-top: percentage(405px / 720px);
        margin: 0 auto;

        video {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
        }
        ::v-deep {
          .jin-player {
            position: absolute;
          }
        }
      }
    }
  }
}
</style>
